(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-help-center')) {
    customElements.define('sm-help-center', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.topic = 'all';
        this.items = Array.from(this.querySelectorAll('[data-help-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-help-group]'));
        this.links = Array.from(this.querySelectorAll('[data-help-topic]'));
        this.query = this.querySelector('[data-help-query]');
        this.clear = this.querySelector('[data-help-clear]');
        this.status = this.querySelector('[data-help-status]');
        this.empty = this.querySelector('[data-help-empty]');
        this.items.forEach(item => { item.searchText = this.normalize(item.textContent); });
        const search = this.querySelector('[data-help-search]');
        if (search) search.hidden = false;
        this.query?.addEventListener('input', () => {
          this.topic = 'all';
          this.filter();
        });
        this.clear?.addEventListener('click', () => {
          this.query.value = '';
          this.topic = 'all';
          this.filter();
          this.query.focus();
        });
        this.links.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.selectTopic(link.dataset.helpTopic);
        }));
        this.querySelectorAll('[data-help-jump]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.selectTopic(link.dataset.helpJump, false);
          this.querySelector('[data-help-group="' + link.dataset.helpJump + '"]')?.scrollIntoView({behavior:this.reducedMotion() ? 'instant' : 'smooth',block:'start'});
        }));
        this.onBlockSelect = event => {
          const block = this.items.find(item => item.dataset.helpBlock === event.detail.blockId);
          if (!block) return;
          this.selectTopic(block.dataset.helpCategory, false);
          block.open = true;
          block.scrollIntoView({block:'center',behavior:'instant'});
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }
      normalize(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g,' ').trim();
      }
      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
      selectTopic(topic, animate = true) {
        this.topic = topic;
        if (this.query) this.query.value = '';
        const update = () => this.filter();
        if (animate && document.startViewTransition && !this.reducedMotion()) document.startViewTransition(update);
        else update();
      }
      filter() {
        const term = this.normalize(this.query?.value || '');
        const words = term.split(' ').filter(Boolean);
        let count = 0;
        this.items.forEach(item => {
          const topicMatches = this.topic === 'all' || item.dataset.helpCategory === this.topic;
          const textMatches = words.every(word => item.searchText.includes(word));
          item.hidden = !(topicMatches && textMatches);
          if (!item.hidden) count++;
        });
        this.groups.forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('[data-help-item]')).some(item => !item.hidden);
        });
        this.links.forEach(link => {
          if (link.dataset.helpTopic === this.topic) link.setAttribute('aria-current','true');
          else link.removeAttribute('aria-current');
        });
        this.status.textContent = this.dataset.resultsPattern.replace('__COUNT__', String(count));
        this.status.hidden = !term;
        if (this.clear) this.clear.hidden = !term;
        this.empty.hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-set-information"]) return;
  try {
    
  if (!customElements.get('sm-set-information')) {
    customElements.define('sm-set-information', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[data-info-panel]')];
        const select = index => {
          tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(index === i)); tab.tabIndex = index === i ? 0 : -1; });
          panels.forEach((panel, i) => { panel.hidden = index !== i; });
        };
        panels.forEach((panel, i) => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tabs[i].id); panel.tabIndex = 0; });
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(i));
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') target = (i + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target === undefined) return;
            event.preventDefault(); select(target); tabs[target].focus();
          });
        });
        this.querySelector('[role="tablist"]').hidden = false;
        select(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
